import { render } from "./SectionGallery.vue?vue&type=template&id=39357f73&scoped=true"
import script from "./SectionGallery.vue?vue&type=script&lang=js"
export * from "./SectionGallery.vue?vue&type=script&lang=js"

import "./SectionGallery.vue?vue&type=style&index=0&id=39357f73&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39357f73"]])

export default __exports__